import {Component, ElementRef, NgZone, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-warehouse-map',
  templateUrl: './warehouse-map.component.html',
  styleUrls: ['./warehouse-map.component.scss']
})
export class WarehouseMapComponent implements OnInit {
  selectedPositionId: number | null = null;

  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  toDashboard() {
    this.router.navigate(['in']);
  }

  openDetails(id: number) {
    this.selectedPositionId = id;
  }

  clearDetails() {
    this.selectedPositionId = null;
  }
}
